export const userSettings = '/user-history/user/:id';
export const userSettingsUpdate = '/property/user/:id';
